module.exports = require('./helpers/bundle-url').getBundleURL('4temp') + "logo_size.fc7c0ced.jpg";